import React, { useState } from "react";

export default function SeconadaryBtn({ label, onClick }) {
  const [isClicked, setIsClicked] = useState(false);

  return (
    <button
      className={`seconadaryBtn_button ${isClicked ? "clicked" : ""}`}
      onClick={onClick}
      onMouseDown={() => setIsClicked(true)}
      onMouseUp={() => setIsClicked(false)}
      onMouseLeave={() => setIsClicked(false)}
    >
      {label}
    </button>
  );
}
